// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"6df1efb9","775":"557966d0"}[chunkId] + ".chunk.js";
};